import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { PostMeta } from '../content/post.model';
import { formatPostDate } from '../site';

/**
 * One post, as a card.
 *
 * Shared by the blog index and the landing page's reading list so the two
 * cannot drift into looking like different products.
 *
 * Five of the posts have a cover and seven do not, because a cover only
 * arrives when the writer sends one. A card with an empty slot where a
 * picture should be reads as broken, so a post without one gets the band
 * instead: the same indigo field the hero and the footer stand on, which is
 * deliberate rather than missing.
 */
@Component({
  selector: 'app-post-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  templateUrl: './post-card.component.html',
})
export class PostCardComponent {
  readonly post = input.required<PostMeta>();

  /**
   * The first card on a page carries the image the reader sees before
   * scrolling, so it loads eagerly. Everything below it waits.
   */
  readonly eager = input(false);

  /** 2 on the blog index, 3 under a section heading. */
  readonly headingLevel = input<2 | 3>(3);

  protected get date(): string {
    return formatPostDate(this.post().date, this.post().lang);
  }
}
